import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageMilan = props => {
  return <CityLandingPage cityKey="Milan" cityConfig={cityContent.milan} {...props} />;
};

export default LandingPageMilan;
